import React from "react";
import { OutlinedInput } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { IMaskInput } from "react-imask";

import { validation } from "../../Utils/validations";

import { phoneNumberMask } from "../../Utils/constants";

import { removeControlCharacters } from "../../Utils/helpers";

export default function UserNameField({ disabled }) {
  const { control } = useFormContext();

  return (
    <Controller
      name="username"
      control={control}
      rules={{
        required: true,
        validate: (username) => {
          return (
            validation.number.isUSPhoneNumber(username) ||
            "Please check that you've entered your phone number correctly"
          );
        },
      }}
      render={({ field }) => (
        <OutlinedInput
          {...field}
          id="username-phone"
          placeholder="Enter phone number"
          inputRef={field.ref}
          inputComponent={UserNameFieldMaskAdapter}
          autoFocus
          disabled={disabled}
          type="tel"
          inputProps={{ inputMode: "tel", autoComplete: "tel", "aria-label": "Phone number" }}
        />
      )}
    />
  );
}
const UserNameFieldMaskAdapter = React.forwardRef((props, ref) => {
  const { onChange, onBlur, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask={phoneNumberMask}
      eager
      inputRef={ref}
      onAccept={(value) => onChange?.(removeControlCharacters(value))}
      onBlur={(e) => onBlur(removeControlCharacters(e.target.value))}
    />
  );
});
